import styles from '@styles/components/General/MultiSelectList.module.css';
import React, { useState } from 'react';
import { v4 as uuid } from 'uuid';

export interface SelectableItem {
	id: string;
	name: string;
	image?: string;
}

interface SearchableListProps {
	items: SelectableItem[];
	itemRenderer: (item: SelectableItem) => React.ReactNode;
    selectedIds: string[];
    setSelectedIds: React.Dispatch<React.SetStateAction<string[]>>;
}

const MultiSelectList: React.FC<SearchableListProps> = ({ items, itemRenderer, selectedIds, setSelectedIds }) => {
	const [searchQuery, setSearchQuery] = useState('');

    const filteredItems = items.filter((item) =>
        item.name.toLowerCase().replace(/\s/g, '').includes(
          searchQuery.toLowerCase().replace(/\s/g, '')
        )
    );

	const toggleSelection = (id: string) => {
        setSelectedIds((prev: string[]) => {
            if (prev.includes(id)) {
                return prev.filter((i) => i !== id);
            } else {
                return [...prev, id];
            }
        });
	};

	return (
		<div className={styles['searchable-list']}>
			<input
				type="text"
				placeholder="Buscar colaborador..."
				value={searchQuery}
				onChange={(e) => setSearchQuery(e.target.value)}
				className={styles['search-box']}
			/>

			<div className={styles['list-container']}>
				{filteredItems
					.sort((a, b) => {
						const aSelected = selectedIds.includes(a.id);
						const bSelected = selectedIds.includes(b.id);
						if (aSelected && !bSelected) return -1;
						if (!aSelected && bSelected) return 1;
						return 0;
					})
					.map((item) => (
						<div
							key={uuid()}
							onClick={() => toggleSelection(item.id)}
							className={`${styles['list-item']} ${
								selectedIds.includes(item.id) ? styles.selected : ''
							}`}
							role="option"
							aria-selected={selectedIds.includes(item.id)}>
							{itemRenderer(item)}
						</div>
					))}
			</div>
		</div>
	);
};

export default MultiSelectList;
